import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
const Tab = ({ onClick , biData , dataHook , isActive , prefix , label , href , postfix , dropdown , viewClassNames: s , innerRef  })=>{
    const watch_ui_updates = useFlag('watch_ui_updates');
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: classnames(s['tab'], isActive && s['active-tab']),
        href: href,
        onClick: onClick,
        biData: biData,
        "data-hook": dataHook,
        innerRef: innerRef
    }, prefix && /*#__PURE__*/ React.createElement("div", {
        className: s['prefix']
    }, prefix), /*#__PURE__*/ React.createElement("span", {
        className: s['label']
    }, label), postfix, watch_ui_updates && dropdown && /*#__PURE__*/ React.createElement("div", {
        className: s['dropdown'],
        onClick: (ev)=>ev.stopPropagation()
    }, dropdown));
};
Tab.displayName = 'Tab';
export default Tab;
